import { render, staticRenderFns } from "./TableWithSearch.vue?vue&type=template&id=0849f6b6&scoped=true"
import script from "./TableWithSearch.vue?vue&type=script&lang=js"
export * from "./TableWithSearch.vue?vue&type=script&lang=js"
import style0 from "./TableWithSearch.vue?vue&type=style&index=0&id=0849f6b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0849f6b6",
  null
  
)

export default component.exports